import {
  Alert,
  Autocomplete,
  Backdrop,
  Button,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Snackbar,
  TablePagination,
  TextField,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import { ArrowBack } from "@material-ui/icons";
import CardText from "../../StyledComponents/Card/CardText";
import CardBody from "../../StyledComponents/Card/CardBody";
import InvoiceTable from "../Home/InvoiceTable";
import React, { useEffect, useState } from "react";
import VendorIRTable from "./vendorIRTable";
import { useDispatch, useSelector } from "react-redux";
import { getUsersByRole, getVendorDetail } from "../Invoices/actions";
import { getInvoicesLandingPage, getRolesData, getUserRoles } from "../Home/actions";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import PageNotFound from "../Invoices/NewInvoice/PageNotFound";
// import ChangeUserPopUp from "./changeUserPopUp";
import { changeUserAction, getChangeUserInvoicesLandingPage } from "./actions";
import CustomSnackbar from "../../CustomSnackbar";
// import CustomSnackbar from "../../CustomSnackbar";

const useStyles = makeStyles(dashboardStyle);
const VendorIRLandingPage = () => {
  const state = useSelector((state) => state.Role);
  const classes = useStyles();
  const [invoices, setInvoices] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [formState, setFormState] = useState({
    id:0,
    Vendor: {
      Vendor_Code: "-1",
      Vendor_Name: "Select Vendor",
    },

    User: null,
      isAsc: "false",
    PageNo: 1,
    RowsOfPage: 25,
  });
  console.log(formState,'formState')
  const [errorMessage, setErrorMessage] = useState("");
  const [ExcelInvoiceListData, setExcelInvoiceListData] = useState([]);
  const [isOrderUpdated, setisOrderUpdated] = useState(true);
  const [AdminRole,setAdminRole]=useState([])
  const [allowToProceed,setAllowToProceed]=useState(true)
  const [roles, setRoles] = useState([ {
    roleId: "013fa4f6-3525-434b-8293-c1a72ef1526f",
    roleName: "IP"
},
{
    roleId: "b5f43efb-f59b-4378-bc3a-586ee4ee7346",
    roleName: "IR"
},])
  const [rolesLoading, setRolesLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [vendorLoading, setVendorLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(true);
  const [statusList, setStatusList] = useState([]);
  const [userData, setUserData] = useState([]);
  const [IRData, setIRData] = useState([]);
  const [IPData, setIPData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredUserData, setFilteredUserData] = useState([]);
  const [changeUser, setChangeUser] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const[comment , setComment] = useState("");
  const [invoicesList, setInvoicesList] = useState([]);
  const [changeUserLoading, setChangeUserLoading] = useState(false);
  const [waitMessage, setWaitMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const invoiceAction = () => {};

  const dispatch = useDispatch();

  const [count, setCount] = useState(0);

  const getInvoices = () => {
    setInvoicesList([])
    getChangeUserInvoicesLandingPage(
      setInvoices,
      setInvoiceLoading,
      formState,
      setCount,
      state.Status,
      isOrderUpdated
    );
  };
  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));

    const updatedFormState = {
      ...formState,
      [name]: value,
    };
if (
  name === "InvoiceNo" ||
  name === "User" ||
  name === "roleName" ||
  name === "Vendor" ||
  name === "SubmissionFromDate" ||
   name === "SubmissionToDate"
) {
  setInvoicesList([])
    getChangeUserInvoicesLandingPage(
      setInvoices,
      setInvoiceLoading,
      updatedFormState,
      setCount,
      state.Status,
      isOrderUpdated
    );
} 
  };



  useEffect(() => {
    getChangeUserInvoicesLandingPage(
      setInvoices,
      setInvoiceLoading,
      formState,
      setCount,
      state.Status,
      isOrderUpdated
    );
  }, [
    formState?.PageNo,
    formState?.RowsOfPage,
    formState?.Generic,
    formState?.isAsc,
    formState?.OrderBy,
    successMessage
  ]);
  useEffect(() => {
    getRolesData(setAdminRole);
  }, []);
  useEffect(()=>{
    if(AdminRole?.length>0){
      const allow=AdminRole?.filter(user => user.roleName && user.roleName?.toLowerCase() === 'admin panel')?.map(role=>role.roleName)
      if(allow[0]?.toLowerCase()=='admin panel'){
        setAllowToProceed(true)
      }
   
    }
  },[AdminRole])
 
  useEffect(() => {
    getVendorDetail(null, setVendors, setVendorLoading);
    // getUsersByRole("Reviewer", setUserData, setLoading);
    const fetchUsers = async () => {
        try {
            setLoading(true);
            // if(formState?.roleName == "IR"){
              setIPData([])
              await getUsersByRole("IR", setIRData, setLoading);
            // }
           if(formState?.roleName == "IP"){
            setIRData([])
            await getUsersByRole("IP", setIPData, setLoading);
           }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };
    
    fetchUsers();
}, [formState?.roleName]); 

  useEffect(() => {
    if (IRData.length > 0 ||  IPData.length > 0) {
        const mergedData = [...IRData, ...IPData];
        const uniqueData = mergedData.filter((value, index, self) => 
          index === self.findIndex((t) => t.userId === value.userId)
      );
        setUserData(uniqueData); 
    }
  }, [IRData, IPData]);

  useEffect(() => {
   const filteredData =  userData?.filter((user)=> user.userId !== formState?.User?.userId )
    setFilteredUserData(filteredData);
  }, [userData , formState?.User]);


  const handleChangePage = (e, newPage) => {
    setFormState({
      ...formState,
      PageNo: newPage + 1,
    });
  };

  const handleChangeRowsPerPage = (e) => {
    setFormState({
      ...formState,
      RowsOfPage: e.target.value,
    });
  };

  const changedUserHandler = (name, val) => {
    setSelectedUser(val?.userId);
  };

  const changeCommentHandler = (name, val) => {
    setComment(val);
  };

  const AddUser = () => {
    // if(selectedUser == "" || selectedUser == undefined){
    //   return
    // }
    // if(comment == "" || comment == undefined){
    //   return
    // }
    // setChangeUserLoading(true);
    // setChangeUser(false);
    // setWaitMessage("Wait.. your request is in progress");
    // const updateForm = () => {
    //   setInvoicesList([]);
    //   // setInvoices([]);
    //   setFormState(() => ({
    //     SubmissionToDate: moment().format("YYYY-MM-DD"),
    //     SubmissionFromDate: moment().subtract(6, "M").format("YYYY-MM-DD"),
    //     roleName: "IR",
    //     RoleId: {
    //       roleId: "b5f43efb-f59b-4378-bc3a-586ee4ee7346",
    //       roleName: "IR",
    //     },
    //     Vendor: {
    //       Vendor_Code: "-1",
    //       Vendor_Name: "All",
    //     },

    //     User: null,
    //     InvoiceNo: "",
    //     OrderBy: "invoice_id",
    //     isAsc: "false",
    //     PageNo: 1,
    //     RowsOfPage: 25,
    //   }));
    // };

    // const IsIRuser = formState?.roleName == "IR" ? true : false
    if(formState?.Vendor?.Vendor_Code==="-1"){
      setErrorMessage("Please select vendor to proceed")
    }else{
    changeUserAction(
       formState, 
       setSuccessMessage,
       setErrorMessage 
    );
  }
  };

  useEffect(()=>{
    if(waitMessage == ""){
      getChangeUserInvoicesLandingPage(
        setInvoices,
        setInvoiceLoading,
        formState,
        setCount,
        state.Status,
        isOrderUpdated
      );
    }
  },[waitMessage])


  return (
    <>
   {allowToProceed ? (
    <Card style={{ marginLeft: "20px" }}>
      <CardHeader color="primary" text>
        <CardText
          style={{
            backgroundColor: "#031C30",
            height: "62px",
            padding: "1px 20px",
            color: "white",
          }}>
          <Grid container justifyContent="space-between">
            <Grid>
              <h4>Vendor IR</h4>
            </Grid>
            {/* <Grid>
                    <IconButton   variant="contained" style={{float: "right", marginTop: "1.5%"}}>
                    <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
                    </IconButton>
                    </Grid> */}
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <form>
          <Grid container spacing={2} mt={0}>
            {/* <Grid item xs={12} lg={6} sm={12} md={6}>
              <Typography>Role:</Typography>
              <Autocomplete
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInputBase-input": {
                    marginTop: "-4px", // Adjust this value to move the text up
                    fontSize: 15,
                  },
                }}
                id="RoleId"
                options={roles?.filter(
                  (item) => item?.roleName === "IR" || item?.roleName === "IP"
                )}
                size="small"
                // classes={{ option: classes.option }}
                name="RoleId"
                value={{ roleName: formState?.roleName || "" }}
                getOptionLabel={(option) =>
                  (option !== "" && `${option?.roleName}`) || ""
                }
                loading={rolesLoading}
                onChange={(event, newValue) => {
                  autocompleteChangeHandler("RoleId", newValue);
                  autocompleteChangeHandler("roleName", newValue?.roleName);
                  //   setFormState((formState) => ({
                  //     ...formState,
                  //     RoleId: newValue,
                  //     roleName: newValue?.roleName,
                  //   }));
                  //   setInvoiceLoading(true);
                  //   setInvoices([]);
                  //   getStatusList(
                  //     setStatusList,
                  //     setStatusLoading,
                  //     state,
                  //     newValue?.roleName,
                  //     dispatch
                  //   );
                  //   dispatch(Role(newValue));
                }}
                renderInput={(params) => (
                  <TextField
                    // sx={{ input: { color: "#888888" } }}
                    {...params}
                    name=""
                    required
                    value={""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </Grid> */}
              <Grid item xs={12} lg={6} sm={12} md={6}>
              <Typography>Vendor:</Typography>
              <Autocomplete
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInputBase-input": {
                    marginTop: "-4px", // Adjust this value to move the text up
                    fontSize: 15,
                  },
                }}
                size="small"
                id="Vendor"
                options={vendors}
                name="Vendor"
                value={formState.Vendor}
                getOptionLabel={(option) =>
                  option !== "" &&
                  `${
                    option?.Vendor_Code !== "-1"
                      ? `${option?.Vendor_Code}-`
                      : ""
                  } ${option?.Vendor_Name}`
                }
                loading={rolesLoading}
                onChange={(event, newValue) => {
                  autocompleteChangeHandler("Vendor", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Vendor"
                    sx={{
                      "& .MuiInputBase-input::placeholder": {
                        opacity: 1,        // increase opacity
                        color: "#000",
                        fontSize: 15
                      }
                    }}
                    name=""
                    required
                    value={""}
                    onChange={(event) => {
                                getVendorDetail(event.target.value, setVendors, setVendorLoading);
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}></TextField>
                )}></Autocomplete>
            </Grid>
            <Grid item xs={12} lg={6} sm={12} md={6}>
              {/* <Typography>IR User:</Typography>
              <Autocomplete
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInputBase-input": {
                    marginTop: "-4px", // Adjust this value to move the text up
                    fontSize: 15,
                  },
                }}
                size="small"
                id="User"
                options={filteredUserData}
                name="User"
                value={formState.User}
                getOptionLabel={(option) =>
                  option !== "" && `${option?.userName}`
                }
                loading={rolesLoading}
                onChange={(event, newValue) => {
                  autocompleteChangeHandler("User", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name=""
                    required
                    value={""}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}></TextField>
                )}></Autocomplete> */}
                <Typography style={{ color: "black" }}>
                                            IR User:{" "}
                                          </Typography>
                                              <Autocomplete
                                              sx={{
                                                "& .MuiInputBase-root": {
                                                  height: (formState.User?.length || 0) === 0 ? "30px" : "auto",
                                                  textAlign: "center",
                                                  display: "flex",
                                                  alignItems: "center",
                                                },
                                                "& .MuiInputBase-input": {
                                                  marginTop: "-4px",
                                                  fontSize: 15,
                                                },
                                              }}
                                              multiple                             
                                              disabled={false}
                                              options={filteredUserData || []} // Ensure options is never undefined
                                              getOptionLabel={(option) => option.userName}
                                              getOptionDisabled={(option) =>
                                                formState?.User?.includes(option?.userId) || false
                                              }
                                              value={formState?.User?.length!==0 && formState?.User?.map((userId) =>
                                                userData?.find((user) => user.userId === userId)
                                              ) || []}
                                              loading={loading}
                                              onChange={(event, newValue) => {
                                                setFormState((prevFormState) => ({
                                                  ...prevFormState,
                                                  User: newValue?.map(user => user?.userId) || [],
                                                }));
                                              }}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  variant="outlined"
                                                  size="small"
                                                   required = {false}
                                                  fullWidth
                                                  placeholder={
                                                    (formState.User?.length || 0) === 0
                                                      ? "Select IR Users"
                                                      : ""
                                                  }
                                                  InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                      <>
                                                        {loading ? (
                                                          <CircularProgress
                                                            color="inherit"
                                                            size={20}
                                                          />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                      </>
                                                    ),
                                                  }}
                                                />
                                              )}
                                              renderTags={(value, getTagProps) =>
                                                value.map((option, index) => (
                                                  <Chip
                                                    key={index}
                                                    label={option?.userName}
                                                    onDelete={() => {
                                                      const updatedUsers = formState?.User?.filter(
                                                        userId => userId !== option.userId
                                                      ) || [];
                                                      setFormState((prevFormState) => ({
                                                        ...prevFormState,
                                                        User: updatedUsers,
                                                      }));
                                                    }}
                                                    deleteIcon={<CloseIcon />}
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      backgroundColor: "#e0e0e0",
                                                      padding: "2px",
                                                      marginRight: "4px",
                                                    }}
                                                    {...getTagProps({ index })}
                                                  />
                                                ))
                                              }
                                            />  
            </Grid>
             
          </Grid>
          {/* <Grid container spacing={2} mt={0}>
            <Grid
              item
              xs={12}
              lg={6}
              sm={12}
              md={6}
              style={{ paddingRight: "15px" }}>
              <Typography>Invoice #:</Typography>
              <input
                type="text"
                name="InvoiceNo"
                id="InvoiceNo"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInputBase-input": {
                    marginTop: "-4px", // Adjust this value to move the text up
                    fontSize: 15,
                  },
                }}
                className={`${classes?.inputField}`}
                style={{ height: 12 }}
                value={formState.InvoiceNo}
                onChange={(e) => {
                  autocompleteChangeHandler("InvoiceNo", e.target.value);
                }}></input>
            </Grid>
            <Grid item xs={12} lg={6} sm={12} md={6}>
              <Typography>Vendor:</Typography>
              <Autocomplete
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInputBase-input": {
                    marginTop: "-4px", // Adjust this value to move the text up
                    fontSize: 15,
                  },
                }}
                size="small"
                id="Vendor"
                options={vendors}
                name="Vendor"
                value={formState.Vendor}
                getOptionLabel={(option) =>
                  option !== "" &&
                  `${
                    option?.Vendor_Code !== "-1"
                      ? `${option?.Vendor_Code}-`
                      : ""
                  } ${option?.Vendor_Name}`
                }
                loading={rolesLoading}
                onChange={(event, newValue) => {
                  autocompleteChangeHandler("Vendor", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="All"
                    sx={{
                      "& .MuiInputBase-input::placeholder": {
                        opacity: 1,        // increase opacity
                        color: "#000",
                        fontSize: 15
                      }
                    }}
                    name=""
                    required
                    value={""}
                    onChange={(event) => {
                                getVendorDetail(event.target.value, setVendors, setVendorLoading);
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}></TextField>
                )}></Autocomplete>
            </Grid>
          </Grid>

          <Grid container spacing={2} mt={0}>
            <Grid
              item
              xs={12}
              lg={6}
              sm={12}
              md={6}
              style={{ paddingRight: "15px" }}>
              <Typography>Submission Date:</Typography>
              <input
                type="date"
                name="SubmissionFromDate"
                id="SubmissionFromDate"
                value={formState?.SubmissionFromDate}
                className={`${classes?.inputField} `}
                style={{ height: 12 }}
                onChange={(e) => {
                  autocompleteChangeHandler(
                    "SubmissionFromDate",
                    e.target.value
                  );
                }}></input>
            </Grid>
            <Grid
              item
              xs={12}
              lg={6}
              sm={12}
              md={6}
              style={{ paddingRight: "15px" }}>
              <Typography>Submission end date:</Typography>
              <input
                type="date"
                name="SubmissionToDate"
                id="SubmissionToDate"
                className={`${classes?.inputField} `}
                value={formState?.SubmissionToDate}
                style={{ height: 12 }}
                onChange={(e) => {
                  autocompleteChangeHandler("SubmissionToDate", e.target.value);
                }}></input>
            </Grid>
          </Grid> */}

          {/* <Grid
            container
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            justifyContent="flex-end"
            style={{ marginBottom: "15px" }}>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              style={{ padding: "6px", marginTop: "20px" }}
              p={4}
              onClick={getInvoices}>
              Show Invoices
            </Button>
          </Grid> */}
          <Grid container item xs={12} sm={12} md={12} lg={12} mb={2}>
            <Grid style={{ marginRight: "20px" }}>
              <Button
                type="button"
                variant="contained"
                size="small"
                color="secondary"
                style={{ padding: "6px", marginTop: "20px" }}
                p={4}
                onClick={AddUser}>
               Save / Update
              </Button>
            </Grid>
            <Grid>
              <Button
                variant="contained"
                size="small"
                color="primary"
                style={{
                  padding: "6px",
                  marginTop: "20px",
                  backgroundColor: "#9FA6B2 ",
                  color: "black",
                }}
                p={4}
                onClick={() => setFormState([])}>
                Cancel
              </Button>
            </Grid>
          </Grid>
         <Grid item xs={12} sm={12} md={12} lg={12}>
        
            {/* <InvoiceTable invoiceList={invoices}></InvoiceTable> */}
            <VendorIRTable
              invoiceList={invoices}
              invoicesList={invoicesList}
              setInvoicesList={setInvoicesList}
              loading={invoiceLoading}
              invoiceAction={invoiceAction}
              formState={formState}
              setFormState={setFormState}
              //   visitedInvoices={visitedInvoices}
              setErrAlertMessage={setErrorMessage}
              setExcelInvoiceListData={setExcelInvoiceListData}
              setisOrderUpdated={setisOrderUpdated}></VendorIRTable>
            {/* <TablePagination
              rowsPerPageOptions={[25, 50, 100, 500, 1000]}
              component="div"
              count={count}
              rowsPerPage={formState.RowsOfPage}
              page={parseInt(formState.PageNo) - 1}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
         
        </Grid>
        </form>

           
      </CardBody>
      {changeUserLoading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={changeUserLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {waitMessage && (
        <Snackbar
          // anchorOrigin={{
          //     vertical: { vertical },
          //     horizontal: { horizontal },
          // }}
          // TransitionComponent={left}
          open={waitMessage !== ""}
          onClose={() => setWaitMessage("")}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          autoHideDuration={4000}

          // message={<span id="message-id">{message}</span>}
        >
          <Alert
            onClose={() => setWaitMessage("")}
            severity="info"
            sx={{ width: "100%" }}
            variant="filled">
            {waitMessage}
          </Alert>
        </Snackbar>
      )}
      {successMessage && (
        <CustomSnackbar
          open={successMessage !== ""}
          message={successMessage}
          handleClose={() => setSuccessMessage("")}
          variant="success"
        />
      )}
      {errorMessage && (
        <CustomSnackbar
          open={errorMessage !== ""}
          message={errorMessage}
          handleClose={() => setErrorMessage("")}
          variant="error"
        />
      )}
      {/* {changeUser && (
        <ChangeUserPopUp
          open={changeUser}
          close={() => setChangeUser(false)}
          submit={ChangeUser}
          selectedUser={selectedUser}
          filteredUserData={filteredUserData}
          autocompleteChangeHandler={changedUserHandler}
          changeCommentHandler = {changeCommentHandler}
          comment = {comment}
          rolesLoading={rolesLoading}></ChangeUserPopUp>
      )} */}
    </Card> ):( <PageNotFound/>)
  }
  </>
  );
};

export default VendorIRLandingPage;
